// libraries
import React from "react";

// styles
import styles from "./styles.module.scss";

// assets
import plane from "src/assets/images/home/airplane.svg";

// components
import { Tooltip } from "antd";

const PlaneWidget = ({ setShowForm }) => {
  const handleClick = () => {
    if (window.innerWidth < 640) {
      setTimeout(() => {
        document.body.classList.add("set-y");
      }, 500);
    }
    setShowForm(true);
  };

  return (
    <Tooltip placement="bottom" title="Search Location">
      <div className={styles.widget} onClick={handleClick}>
        <img src={plane} alt="plane" />
      </div>
    </Tooltip>
  );
};

export default PlaneWidget;
